import monthlyPayoutSaga from 'features/revenue/itemSales/monthlyPayoutSaga';
import revenueDetailSaga from 'features/revenue/itemSales/revenueDetailSaga';
import sellerRevenueSaga from 'features/revenue/itemSales/sellerRevenueSaga';
import withholdingTaxSaga from 'features/revenue/itemSales/withholdingTaxSaga';
import { all, fork } from 'redux-saga/effects';

export default function* revenueSaga() {
  yield all([
    fork(sellerRevenueSaga),
    fork(monthlyPayoutSaga),
    fork(revenueDetailSaga),
    fork(withholdingTaxSaga),
  ]);
}
